import React from 'react';

import { COLOR } from '@/shared/design-tokens/design-tokens';

type ClearIconProps = {
  className?: string;
  style?: React.CSSProperties;
  size?: number;
  backgroundColor?: string;
  iconColor?: string;
};

export const ClearIcon = ({
  className,
  style,
  size = 20,
  backgroundColor = COLOR.GRAY[70],
  iconColor = COLOR.GRAY[100],
}: ClearIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}>
      <rect x="1.25" y="1.25" width="17.5" height="17.5" rx="8.75" fill={backgroundColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.94194 7.05806C7.69786 6.81398 7.30214 6.81398 7.05806 7.05806C6.81398 7.30214 6.81398 7.69786 7.05806 7.94194L9.11612 10L7.05806 12.0581C6.81398 12.3021 6.81398 12.6979 7.05806 12.9419C7.30214 13.186 7.69786 13.186 7.94194 12.9419L10 10.8839L12.0581 12.9419C12.3021 13.186 12.6979 13.186 12.9419 12.9419C13.186 12.6979 13.186 12.3021 12.9419 12.0581L10.8839 10L12.9419 7.94194C13.186 7.69786 13.186 7.30214 12.9419 7.05806C12.6979 6.81398 12.3021 6.81398 12.0581 7.05806L10 9.11612L7.94194 7.05806Z"
        fill={iconColor}
      />
    </svg>
  );
};
